export const QuickAccessContent = ({
  title,
  description,
  titleClassName = 'line-clamp-1 overflow-hidden text-left text-[18px] font-bold text-primaryDark line-clamp-2 leading-[20px]',
  descriptionClassName = 'line-clamp-3 text-justify text-[14px] leading-[15px] text-tundora',
  containerClassName = 'flex w-[168px] flex-1 flex-col gap-[3px]',
}: {
  title?: string | null;
  description?: string | null;
  titleClassName?: string;
  descriptionClassName?: string;
  containerClassName?: string;
}) => (
  <div className={containerClassName}>
    <div className={titleClassName}>{title || ''}</div>
    {description && <div className={descriptionClassName}>{description}</div>}
  </div>
);
